// Lib
import React, { useMemo } from 'react';
import { Button } from '@mui/material';
import { useSelector } from 'react-redux';

// Components
import EditRecurrenceButton from '../../../components/OrderHistory/Buttons/EditRecurrenceButton';
import SkipButton from '../../../components/OrderHistory/Buttons/SkipButton';
import DetailsButton from '../../../components/OrderHistory/Buttons/DetailsButton';
import AddressesTruncatedLabel from '../../../components/OrderHistory/Labels/AddressesTruncatedLabel';

// Hooks
import useRecurringOrder from './useRecurringOrder';

// Utils
import { getOrderQty, getTotalOrderedQty } from '../utils/getQuantity';
import { getFormattedNextRunDate } from '../../../utils/date';

// Selectors
import { productsObjSelector } from '../../../store/selectors';

// Styles
import { useStyles } from './useRecurringOrderCellReducerStyles';

const useRecurringOrderCellReducer = ({ order }) => {
  const productsObj = useSelector((state) => productsObjSelector(state));
  const { classes } = useStyles();
  const { onEditRecurrence, onCancel, onSkip, loadingSkip } =
    useRecurringOrder(order);

  const cells = useMemo(
    () => ({
      nextShipping: getFormattedNextRunDate(order?.next_run),
      shippingAddress: (
        <AddressesTruncatedLabel
          order={order}
          stringsQty={2}
          className={classes.address}
        />
      ),
      orderQty: getOrderQty(order),
      totalOrdered: (
        <span className={classes.totalItems}>
          {getTotalOrderedQty(order, productsObj)}
        </span>
      ),
      editRecurrence: <EditRecurrenceButton onClick={onEditRecurrence} />,
      cancel: (
        <Button
          onClick={onCancel}
          className={classes.cancelButton}
          data-testid="cancel-recurrence-button">
          Cancel
        </Button>
      ),
      skip: (
        <SkipButton
          loading={loadingSkip}
          onClick={onSkip}
          data-testid="skip-recurrence-button"
        />
      ),
      details: (
        <DetailsButton
          to={`${order.id}`}
          data-testid="recurrence-details-button"
        />
      ),
    }),
    [
      order,
      productsObj,
      onEditRecurrence,
      onCancel,
      loadingSkip,
      onSkip,
      classes,
    ],
  );

  return { cells };
};

export default useRecurringOrderCellReducer;
